import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// Componentes
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import ButtonSpinner from "../../components/Buttons/ButtonSpinner";

// Services
import { createApp } from "../../utils/services/mobileApps";
import { getFirebaseProjects } from "../../utils/services/firebaseProjects";

// Utils
import { getMenusDefault } from "./menuDefault";

import "./styled.css";

export default function NewApps(props) {
  const { isOpen, toggle, refetch, contractId } = props;
  const [isLoading, setIsloading] = useState(false);
  const { token } = useSelector((state) => state.global_user_data.data);
  const [modalBackdrop, setModalBackdrop] = useState(false);

  //campos fomulário
  const [app, setApp] = useState("");
  const [bundleId, setBundleId] = useState("");
  const [termoDeAcesso, setTermoDeAcesso] = useState("");
  const [telaPrincipal, setTelaPrincipal] = useState("Geral");
  const [checkMfa, setCheckMfa] = useState(false);
  const [checkPlayStore, setCheckPlayStore] = useState(false);
  const [checkCaptcha, setCheckCaptcha] = useState(false);
  const [checkEmailLock, setCheckEmailLock] = useState(false);

  //validações campos formulários
  const [appError, setAppError] = useState(false);
  const [bundleIdError, setBundleIdError] = useState(false);
  const [idFirebaseProjectError, setIdFirebaseProjectError] = useState(false);

  //cadastrado com sucesso
  const [success, setSuccess] = useState(false);

  // state projeto firebase
  const [firebaseProjects, setFirebaseProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);

  // state options da tela principal
  const [options, setOptions] = useState([]);
  const [config, setConfig] = useState([]);

  // alterna o backdrop do modal
  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  // limpa os campos e erros do formulário
  function resetFields() {
    setApp("");
    setBundleId("");

    setAppError(false);
    setBundleIdError(false);
    setIdFirebaseProjectError(false);
  }

  // converte o nome da tela principal selecionada para o code esperado pela API
  const getCode = (value) => {
    switch (value) {
      case "Geral":
        return "GERAL";
      case "Agenda":
        return "AGENDA";
      case "Feed":
        return "FEED";
      case "Localização":
        return "LOCALIZATION";
      case "Logística":
        return "LOGISTICA";
      case "Ranking":
        return "RANKING";
      case "Convidados":
        return "CONVIDADOS";
      case "Networking":
        return "NETWORKING";
      case "Notes":
        return "NOTES";

      default:
        return "";
    }
  };

  // valida os campos obrigatórios e envia o cadastro do app
  async function submitForm() {
    if (app === "") {
      return setAppError(true);
    } else setAppError(false);

    if (!selectedProject || selectedProject === "Selecione") {
      return setIdFirebaseProjectError(true);
    } else setIdFirebaseProjectError(false);

    if (bundleId === "") {
      return setBundleIdError(true);
    } else setBundleIdError(false);
    setIsloading(true);

    const apiData = {
      jwt: token,
      name: app,
      bundleId,
      idFirebaseProject: selectedProject,
      contractId,
      termoDeAcesso: termoDeAcesso,
      telaPrincipal:
        telaPrincipal === "Selecione" ? "" : getCode(telaPrincipal),
      hasMfa: checkMfa,
      hasRecaptcha: checkCaptcha,
      hasAppintegrity: checkPlayStore,
      hasRecoveryPasswordSecure: checkEmailLock,
    };

    return createApp({ data: apiData })
      .then((data) => {
        setIsloading(false);
        setSuccess(true);
        resetFields();
      })
      .then(() => refetch())
      .catch((error) => {
        setIsloading(false);

        // console.log({ error });
      });
  }

  // carrega as opções de tela principal disponíveis
  function getMenus() {
    const newOptions = getMenusDefault();
    setOptions([...newOptions]);
  }
  useEffect(() => {
    if (isOpen) {
      getMenus();
      getFBProjects();
      return;
    }
    setSelectedProject(null);
    setSelectedProject(null);
  }, [isOpen]);

  // busca os projetos do Firebase disponíveis para vincular ao app
  function getFBProjects() {
    getFirebaseProjects({ jwt: token }).then((res) => {
      setFirebaseProjects(res.findAll.data);
    });
  }

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      toggle={() => {
        toggleBackdrop();
      }}
      onClosed={() => {
        resetFields();
      }}
      autoFocus={true}
      centered={true}
    >
      {success && (
        <SweetAlert
          success
          title="Cadastro"
          onConfirm={() => {
            setSuccess(false);
            toggle();
          }}
        >
          App cadastrado com sucesso!
        </SweetAlert>
      )}
      <ModalHeader toggle={toggle}>Novo App</ModalHeader>
      <ModalBody>
        <form onSubmit={(e) => e.preventDefault()}>
          <div>
            <Row style={{ marginTop: 10 }}>
              <Col>
                <label
                  className="form-label text-sm"
                  style={{ display: "flex" }}
                >
                  Nome do Aplicativo*
                  <div
                    id="nameApp"
                    style={{ height: "16px", paddingRight: "7px" }}
                  >
                    <div className="show-tips">
                      <span>?</span>
                    </div>
                    <UncontrolledTooltip
                      style={{ backgroundColor: "#6f42c1" }}
                      placement="right"
                      target="nameApp"
                    >
                      Nome que será exibido nas lojas e no dispositivo do
                      usuário quando o APP for baixado
                    </UncontrolledTooltip>
                  </div>
                </label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setApp(e.target.value)}
                />
                {appError && (
                  <span style={{ color: "red" }}>
                    O campo Nome do Aplicativo é obrigatório.
                  </span>
                )}
              </Col>
            </Row>
          </div>
          <div>
            <Row style={{ marginTop: 10 }}>
              <Col>
                <label
                  className="form-label text-sm"
                  style={{ display: "flex" }}
                >
                  ID do Projeto (Firebase)*
                  <div
                    id="projectId"
                    style={{ height: "16px", paddingRight: "7px" }}
                  >
                    <div className="show-tips">
                      <span>?</span>
                    </div>
                    <UncontrolledTooltip
                      style={{ backgroundColor: "#6f42c1" }}
                      placement="right"
                      target="projectId"
                    >
                      Projeto do Firebase que será responsável por enviar os
                      pushs e guardar as informações do chat individual,
                      anotações, super tela
                    </UncontrolledTooltip>
                  </div>
                </label>
                <select
                  className="form-control"
                  onChange={(e) => {
                    setSelectedProject(e.target.value);
                  }}
                >
                  <option>Selecione</option>
                  {firebaseProjects &&
                    firebaseProjects?.map((e, i) => (
                      <option key={i}>{e.name}</option>
                    ))}
                </select>
                {idFirebaseProjectError && (
                  <span style={{ color: "red" }}>
                    O campo ID do Projeto (Firebase) é obrigatório.
                  </span>
                )}
              </Col>
            </Row>
          </div>

          <div>
            <Row style={{ marginTop: 10 }}>
              <Col>
                <label
                  className="form-label text-sm"
                  style={{ display: "flex" }}
                >
                  Bundle ID*
                  <div
                    id="bundleId"
                    style={{ height: "16px", paddingRight: "7px" }}
                  >
                    <div className="show-tips">
                      <span>?</span>
                    </div>
                    <UncontrolledTooltip
                      style={{ backgroundColor: "#6f42c1" }}
                      placement="right"
                      target="bundleId"
                    >
                      Código identificador do APP nas lojas
                    </UncontrolledTooltip>
                  </div>
                </label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setBundleId(e.target.value)}
                />
                {bundleIdError && (
                  <span style={{ color: "red" }}>
                    O campo Bundle ID é obrigatório.
                  </span>
                )}
              </Col>
            </Row>
          </div>

          <div>
            <Row style={{ marginTop: 10 }}>
              <Col>
                <label
                  className="form-label text-sm"
                  style={{ display: "flex" }}
                >
                  Termo de Acesso
                  <div
                    id="term"
                    style={{ height: "16px", paddingRight: "7px" }}
                  >
                    <div className="show-tips">
                      <span>?</span>
                    </div>
                    <UncontrolledTooltip
                      style={{ backgroundColor: "#6f42c1" }}
                      placement="right"
                      target="term"
                    >
                      Termo de acesso que será carregado ao clicar no link da
                      tela de login, caso deixe o campo em branco o aplicativo
                      exibirá a politica de privacidade da Inteegra
                    </UncontrolledTooltip>
                  </div>
                </label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setTermoDeAcesso(e.target.value)}
                />
              </Col>
            </Row>
          </div>

          <Row style={{ marginTop: 10, marginBottom: 20 }}>
            <Col lg={12}>
              <label className="form-label text-sm" style={{ display: "flex" }}>
                Tela Principal
                <div
                  id="mainScreen"
                  style={{ height: "16px", paddingRight: "7px" }}
                >
                  <div className="show-tips">
                    <span>?</span>
                  </div>
                  <UncontrolledTooltip
                    style={{ backgroundColor: "#6f42c1" }}
                    placement="right"
                    target="mainScreen"
                  >
                    Tela que será exibida ao abrir o aplicativo quando o
                    participante tiver apenas 1 evento
                  </UncontrolledTooltip>
                </div>
              </label>
              <select
                className="form-control"
                onChange={({ target }) => setTelaPrincipal(target.value)}
              >
                {options &&
                  options
                    .filter(
                      (e) =>
                        !config.find(
                          (a) => a.code === e.option || a.code === e.code,
                        ),
                    )
                    .map((e, i) => (
                      <option key={i}>{e?.describe || e.option}</option>
                    ))}
              </select>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <label style={{ fontSize: 17 }}>Requisitos de Segurança</label>
            </Col>
          </Row>

          <Row>
            <Col md={12} style={{ display: "flex", flexDirection: "column" }}>
              <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkMfa"
                  onChange={(e) => setCheckMfa(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="checkMfa">
                  Habilitar MFA no Login
                </label>
              </div>

              <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkPlayStore"
                  onChange={(e) => setCheckPlayStore(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="checkPlayStore">
                  Habilitar Integridade (Play Store)
                </label>
              </div>

              <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkCaptcha"
                  onChange={(e) => setCheckCaptcha(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="checkCaptcha">
                  Habilitar CAPTCHA
                </label>
              </div>

              <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkEmailLock"
                  onChange={(e) => setCheckEmailLock(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="checkEmailLock">
                  Retirar trava de email inválido do esqueceu senha
                </label>
              </div>
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              marginTop: 15,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              color="success"
              className="btn btn-danger waves-effect waves-light"
              style={{ width: 80, marginRight: 5 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>
            <ButtonSpinner
              isLoading={isLoading}
              title={"Salvar"}
              onClick={submitForm}
            />
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}
